module.exports = __webpack_public_path__ + "static/media/cn-player-error.586ea99c.jpg";